module.exports = ({React,connect,collectionSearch,Route,LuluList,LuluActions,LuluModal,Crud,Search})-> #,LuluList,LuluActions,LuluStore

  class LuluPanel extends React.Component
    
    constructor:(props)->
      super(props)
      @state = {}

    componentDidMount: ->
      @props.dispatch(LuluActions.lulusLoad())

    onEdit:(idx)->
      return if !@props.lulusSelected?
      ids = @props.lulusSelected.map((row)=> row.id).join(",")
      @props.history.push("/ecommerce/lulu/" + ids) if ids 

    onSelect:(idx)-> LuluActions.select(idx)

    render: ->
      <React.Fragment>
        <div className="duoPanel row6">
          <h4>Lulu Jobs</h4>
          <div className="lulu_panel">
            <div className="row buttonbar">
              <div className="col-xs-7 btn-group">
                <Crud
                  editTitle="edit Lulu" 
                  onEdit={=> @onEdit()} 
                  areSelected={@props.lulusSelected && @props.lulusSelected.length > 0}
                  />
              </div>
              <div className="col-xs-5">
                <Search searchterm={@props.lulusSearchTerm} onChange={(value)=> @props.dispatch(LuluActions.lulusSetSearchTerm(value))} />
              </div>
            </div>
            <div className="content tools">
              <LuluList onEdit={=> @onEdit()} />
            </div>
            
          </div>
          
        </div>
        <Route path="/ecommerce/lulu/:lulu_id" component={LuluModal} />
      </React.Fragment>

  return connect(
    (state)=>
      filters = {}
      return ({
        lulus: collectionSearch(state.lulus,filters,state.lulusSearchTerm),
        lulusAreLoading: state.lulusAreLoading,
        lulusSelected: state.lulusSelected
        lulusSearchTerm: state.lulusSearchTerm
      })
    )(LuluPanel)